var map = {
	"./Customer.svg": 10499,
	"./Group.svg": 29212,
	"./Phone.svg": 9837,
	"./Skill.svg": 36994,
	"./adminprojects-active.svg": 61881,
	"./adminprojects.svg": 55050,
	"./adminusers-active.svg": 54695,
	"./adminusers.svg": 34492,
	"./allfiles.svg": 46049,
	"./application-review.svg": 50444,
	"./banner-default.svg": 9241,
	"./brand-profile-active.svg": 2245,
	"./brand-profile.svg": 40094,
	"./brief.svg": 8669,
	"./broom.svg": 9862,
	"./brush_cc.svg": 38782,
	"./businessOwner.svg": 87770,
	"./businesses-new-active.svg": 99463,
	"./businesses-new.svg": 68700,
	"./businesses.svg": 12137,
	"./calendar-active.svg": 41360,
	"./calendar-check.svg": 98242,
	"./calendar.svg": 33181,
	"./calender-new.svg": 10044,
	"./calendly.svg": 99433,
	"./call.svg": 50259,
	"./camera-circle.svg": 87015,
	"./camera-filled.svg": 127,
	"./camera.svg": 88218,
	"./camera_event.svg": 95803,
	"./clock.svg": 90983,
	"./comment.svg": 93194,
	"./content_plan-active.svg": 96979,
	"./content_plan.svg": 17552,
	"./coupon_apply.svg": 5056,
	"./coupons-active.svg": 64043,
	"./coupons.svg": 86040,
	"./creative.svg": 97912,
	"./creative_2.svg": 31631,
	"./document_check.svg": 67937,
	"./dollar-active.svg": 5008,
	"./dollar.svg": 2589,
	"./dollar_2.svg": 60866,
	"./download.svg": 19395,
	"./edit-circle.svg": 71800,
	"./edit2.svg": 45283,
	"./facebook.svg": 27355,
	"./feedback.svg": 79598,
	"./folder.svg": 79047,
	"./gallery.svg": 34919,
	"./gear-active.svg": 69545,
	"./gear.svg": 43386,
	"./get-started_bs.svg": 75821,
	"./google.svg": 43826,
	"./gray-check.svg": 64245,
	"./green-check.svg": 18351,
	"./grid.svg": 77083,
	"./grid2.svg": 78563,
	"./hangTight.svg": 24569,
	"./help.svg": 6278,
	"./homedashboard-active.svg": 59145,
	"./homedashboard.svg": 93082,
	"./i-icon.svg": 71014,
	"./info.svg": 92591,
	"./instagram.svg": 56137,
	"./invite_clock.svg": 9183,
	"./library-active.svg": 9635,
	"./library.svg": 86016,
	"./linkedin.svg": 66749,
	"./location.svg": 98898,
	"./logo-colored.svg": 307,
	"./logo-short-colored.svg": 34106,
	"./logo-short.svg": 16047,
	"./logo.svg": 65318,
	"./logout.svg": 13017,
	"./mail.svg": 43930,
	"./matchToGigis.svg": 1256,
	"./nav-back.svg": 40710,
	"./no-events.svg": 12452,
	"./noTask.svg": 46389,
	"./no_active_orders.svg": 57121,
	"./not-a-good-match.svg": 10410,
	"./organisations.svg": 69996,
	"./paycenter-active.svg": 99915,
	"./paycenter.svg": 50968,
	"./photoshootEquipment.svg": 90914,
	"./pinterest.svg": 3355,
	"./producer.svg": 23941,
	"./productionmenu-active.svg": 44358,
	"./productionmenu.svg": 29447,
	"./profile-circle.svg": 32775,
	"./project-overview.svg": 17018,
	"./projects-active.svg": 49208,
	"./projects.svg": 25013,
	"./resourceCenter.svg": 5444,
	"./subscriptions-active.svg": 8926,
	"./subscriptions.svg": 87311,
	"./support.svg": 98616,
	"./theme/CalendarBlank.svg": 73019,
	"./theme/Delete.svg": 91300,
	"./theme/EnvelopeSimple.svg": 53059,
	"./theme/Illustration-4.svg": 29844,
	"./theme/ai.svg": 80139,
	"./theme/archive.svg": 10629,
	"./theme/assign.svg": 17834,
	"./theme/attach.svg": 77390,
	"./theme/bar-large.svg": 86710,
	"./theme/bar-small.svg": 66378,
	"./theme/bell-icon.svg": 89812,
	"./theme/bell-icon_white.svg": 39470,
	"./theme/brand-profile.svg": 53464,
	"./theme/brandquiz/brainstorm.svg": 31821,
	"./theme/brandquiz/brand vision.svg": 88035,
	"./theme/brandquiz/brand_colors.svg": 21252,
	"./theme/brandquiz/brand_fonts.svg": 48142,
	"./theme/brandquiz/brand_style.svg": 8087,
	"./theme/brandquiz/general.svg": 29630,
	"./theme/brandquiz/logo_files.svg": 97059,
	"./theme/brandquiz/media-pause.svg": 87863,
	"./theme/brandquiz/media-play.svg": 67889,
	"./theme/brandquiz/media-stop.svg": 68367,
	"./theme/brandquiz/music.svg": 36835,
	"./theme/brandquiz/pause_button.svg": 47943,
	"./theme/brandquiz/quiz.svg": 64445,
	"./theme/calendar-client.svg": 98341,
	"./theme/calendar-notification.svg": 61749,
	"./theme/calendar.svg": 13567,
	"./theme/calender.svg": 69755,
	"./theme/camera.svg": 66296,
	"./theme/check-gray.svg": 58001,
	"./theme/check-green.svg": 64469,
	"./theme/check-white.svg": 13427,
	"./theme/check_circle.svg": 84518,
	"./theme/checkmark.svg": 1388,
	"./theme/client.svg": 47256,
	"./theme/clock.svg": 49105,
	"./theme/close-small.svg": 66885,
	"./theme/cloud-computing.svg": 42693,
	"./theme/common.svg": 88234,
	"./theme/content-delivery.svg": 21941,
	"./theme/content-kit.svg": 8291,
	"./theme/contract.svg": 57067,
	"./theme/dashboard-client-tracker.svg": 26894,
	"./theme/deliverables-update.svg": 95051,
	"./theme/demo-avatar.svg": 10934,
	"./theme/doc.svg": 54753,
	"./theme/dollar.svg": 87563,
	"./theme/download-small.svg": 21523,
	"./theme/download.svg": 16257,
	"./theme/edit-icon.svg": 98461,
	"./theme/edit-small.svg": 6859,
	"./theme/edit.svg": 72729,
	"./theme/email-outline.svg": 93786,
	"./theme/empty-deliverables.svg": 51715,
	"./theme/empty-girl.svg": 62051,
	"./theme/empty-pie-chart.svg": 5710,
	"./theme/empty-plane.svg": 84465,
	"./theme/empty-profile.svg": 76980,
	"./theme/error-notifier.svg": 62520,
	"./theme/exclamatory.svg": 90690,
	"./theme/facebook-outline.svg": 41300,
	"./theme/facebook.svg": 32641,
	"./theme/favorite.svg": 52581,
	"./theme/file-upload.svg": 32135,
	"./theme/filter-icon-selected.svg": 8731,
	"./theme/filter-icon.svg": 31055,
	"./theme/fnt.svg": 74899,
	"./theme/folder.svg": 38593,
	"./theme/fon.svg": 54106,
	"./theme/freelancer.svg": 76078,
	"./theme/globe-outline.svg": 33069,
	"./theme/grid-view-icon.svg": 93421,
	"./theme/group-message-icon.svg": 8786,
	"./theme/group.svg": 96314,
	"./theme/image.svg": 80236,
	"./theme/info.svg": 56593,
	"./theme/instagram-outline.svg": 92646,
	"./theme/instagram.svg": 46019,
	"./theme/jpg.svg": 16466,
	"./theme/linkedin-outline.svg": 21290,
	"./theme/list-view-icon.svg": 10777,
	"./theme/location-outline.svg": 58129,
	"./theme/location.svg": 58336,
	"./theme/main.svg": 30418,
	"./theme/matched-creative.svg": 28003,
	"./theme/more-details-arrow.svg": 56979,
	"./theme/move.svg": 62218,
	"./theme/mp3.svg": 37193,
	"./theme/mp4.svg": 7750,
	"./theme/no-creative-team.svg": 38599,
	"./theme/no-notification.svg": 34332,
	"./theme/no-sweeps-calendar.svg": 68781,
	"./theme/onboarding-client-creative.svg": 83680,
	"./theme/onboarding-client.svg": 26126,
	"./theme/onboarding-creative.svg": 1356,
	"./theme/open-in-new.svg": 46170,
	"./theme/pdf.svg": 38109,
	"./theme/phone-outline.svg": 89386,
	"./theme/pinterest.svg": 15761,
	"./theme/play-button.svg": 34060,
	"./theme/plus-circle.svg": 75718,
	"./theme/plus.svg": 8937,
	"./theme/png.svg": 39646,
	"./theme/profile-executive.svg": 43765,
	"./theme/profile-without-subscription.svg": 7295,
	"./theme/profile.svg": 72904,
	"./theme/profileWithoutBorder.svg": 73926,
	"./theme/progress.svg": 424,
	"./theme/project-banner-default.svg": 51095,
	"./theme/psd.svg": 1326,
	"./theme/release.svg": 86316,
	"./theme/remove.svg": 71129,
	"./theme/slack-outline.svg": 1390,
	"./theme/slack.svg": 95291,
	"./theme/srt.svg": 43430,
	"./theme/start-up.svg": 5079,
	"./theme/svg.svg": 69033,
	"./theme/tag.svg": 6743,
	"./theme/trash.svg": 96929,
	"./theme/ttf.svg": 28321,
	"./theme/upload.svg": 67606,
	"./theme/user-outline-2.svg": 13212,
	"./theme/user-outline.svg": 20061,
	"./theme/user.svg": 85796,
	"./theme/verified.svg": 40985,
	"./theme/welcome.svg": 56823,
	"./theme/welcome_new.svg": 84720,
	"./theme/youtube-outline.svg": 65949,
	"./theme/zip.svg": 38394,
	"./tutorial.svg": 46957,
	"./two_people.svg": 46539,
	"./upload-gray.svg": 89240,
	"./upload-thick.svg": 8816,
	"./user.svg": 88670,
	"./users.svg": 7041,
	"./usersIcon-active.svg": 97573,
	"./usersIcon.svg": 24510,
	"./verticaldots.svg": 99197,
	"./video-circle.svg": 87273,
	"./youtube.svg": 54762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57477;